import { render, staticRenderFns } from "./SlideTypeItem.vue?vue&type=template&id=b7eb8f88&scoped=true&"
import script from "./SlideTypeItem.vue?vue&type=script&lang=js&"
export * from "./SlideTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./SlideTypeItem.vue?vue&type=style&index=0&id=b7eb8f88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7eb8f88",
  null
  
)

export default component.exports